/*
 Copyright (c) 2015, salesforce.com, inc. All rights reserved.

 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from '@salesforce/design-system-react';
import JourneyTemplateCarousel from './journey-template-carousel';

const deepLinkOptions = {
  appName: 'Journey Builder',
  analyticsName: 'Journey Builder View All Templates',
  link: '/#templates',
};

function JourneyTemplateWidget(props) {
  return (
    <div className="slds-p-top--large journey-templates">
      <div className="journey-templates-header">
        <div className="journey-templates-header-title slds-float_left">
          <div className="slds-float_left">
            <Icon category="custom" name="custom106" size="medium" />
          </div>
          <h1 className="slds-text-heading--medium slds-float_left">
            {props.localizations['homepage.templates.journey_templates']}
          </h1>
        </div>
        <div className="journey-templates-header-link slds-float_right">
          <a
            className="bg-link"
            href="/"
            onClick={() => {
              props.onDeepLink(deepLinkOptions);
            }}
          >
            {props.localizations['homepage.templates.view_all_templates']}
          </a>
        </div>
      </div>

      <div className="journey-templates-content">
        <JourneyTemplateCarousel templates={props.templates} onDeepLink={props.onDeepLink} />
      </div>
    </div>
  );
}

JourneyTemplateWidget.displayName = 'Journey Template Widget';

JourneyTemplateWidget.propTypes = {
  templates: PropTypes.array,
  onDeepLink: PropTypes.func,
  localizations: PropTypes.object,
};

export default JourneyTemplateWidget;
